import { render, staticRenderFns } from "./contentCompanyCreate.vue?vue&type=template&id=e86681c0&"
import script from "./contentCompanyCreate.vue?vue&type=script&lang=js&"
export * from "./contentCompanyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports